import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  effect,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ThemeModeService } from '@ui-kit';
import { TitleService } from '@core-utils';
import { environment } from '@environments/environment';
import { UserService } from '@shared/auth';
import init from 'helphero';

@Component({
  imports: [RouterModule],
  selector: 'mjp-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private themeModeService = inject(ThemeModeService);
  private titleService = inject(TitleService);
  private userService = inject(UserService);

  constructor() {
    const helpHeroAppId = environment.helpHeroAppId;

    if (helpHeroAppId) {
      const helpHero = init(helpHeroAppId);

      effect(() => {
        const user = this.userService.currentUser();
        if (user?.id) {
          helpHero.identify(user.id);
        }
      });
    }
  }

  ngOnInit() {
    this.themeModeService.init();
    this.titleService.setTitle('MjPoints', environment);
  }
}
